import {locale} from './locale.js';
import Vue from 'vue'
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const lang = (locale[Vue.$cookies.get('language')] && Vue.$cookies.get('language')) || 'ru-ru';

const text = locale[lang];

export const steps = [

    {
        id : 'calculation_mode',
        title: text.stepInfo.calculation_mode.title,
        active : true,
        description : ''
    },

    {
        id : 1,
        title: text.stepInfo.roofing_material.title,
        active : false,
        description : text.stepInfo.roofing_material.description
    },
    {
        id : 2,
        title: text.stepInfo.roofing_lenght_and_heating_width.title,
        active : false,
        description : text.stepInfo.roofing_lenght_and_heating_width.description
    },
    {
        id: 'product_list',
        title : text.stepInfo.product_list.title,
        sub_title : text.stepInfo.product_list.sub_title,
        active : false,
        description : text.stepInfo.product_list.description
    }
];

export const criteria = [
    {
        id : 1,
        name : 'roofing_material',
        inputType : 'radio',
        stepId : 1,
        values : [
            {
                id : 1,
                value: 'metalic',
                text : text.criteriaValues.metalic,
            },
            {
                id : 2,
                value: 'natural_tile',
                text : text.criteriaValues.natural_tile,
            },
            {
                id : 3,
                value: 'sorf_roof',
                text : text.criteriaValues.soft_roof,
            },
        ],

    },

    {
        id : 2,
        name : 'roofing_lenght',
        inputType : 'text',
        image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/roof/roofing_lenght.gif',
        stepId : 2,
        placeholder: text.criteriaValues.roofing_length_placeholder,
        postfix: 'м',
        title: text.criteriaValues.roofing_length_title,

    },
    {
        id : 3,
        name : 'heating_width',
        inputType : 'text',
        image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/roof/heating_width.gif',
        stepId : 2,
        placeholder: text.criteriaValues.heating_width_placeholder,
        postfix: 'м',
        title: text.criteriaValues.heating_width_title,

    },


];